// extracted by mini-css-extract-plugin
module.exports = {"garderobo":"ButtonBack_garderobo__3tTeK"};